import React, { useEffect } from "react";
import styles from "./sku-details.scss";
import ComponentsContainer from "../../../insights-board/components-container/components-container";
import PanelComponent from "../../../../components/dashboard-components/panel-component/panel-component";
import panelStyles from "../../../insights-board/mb-components/category-customer-panel-component/category-customer-panel-component.scss";
import { CategoryCustomerPanelComponentConfig } from "../../../insights-board/mb-components/category-customer-panel-component/category-customer-panel-component-config";
import insightsCellStyles from "../../../insights-board/mb-components/category-customer-panel-component/category-customer-panel-component.scss";
import { connect } from "react-redux";
import SkuDetailsCell from "./sku-details-cell/sku-details-cell";
import skuDetailsCellStyles from "./sku-details-cell/sku-details-cell.scss";
import * as Decorators from "../../../../styles/cell-decorators";
import { STATUS_LOADING, STATUS_SUCCESS } from "../../constants";

const skuDetailsPanelConfig = (currency) => {
  return {
    totalSalesDollars: {
      type: "data",
      title: "Total Sales Dollars",
      taglineAccessor: null,
      accessorSection: "category",
      valueAccessor: "currentSkuSalesDollars",
      valueDecorator: Decorators.priceDecoratorWrapper(
        currency,
        "current_sku_sales_dollars_"
      ),
      diffAccessor: "skuSalesDollarsChange",
      diffDecorator: Decorators.numberChangeDecorator,
      tooltip: null,
      style: {},
      valueStyle: insightsCellStyles.largeValue,
    },
    unitsSold: {
      type: "data",
      title: "Total Units",
      taglineAccessor: null,
      accessorSection: "category",
      valueAccessor: "currentSkuUnitsSold",
      valueDecorator: Decorators.salesDecorator("sales"),
      diffAccessor: "skuUnitsSoldChange",
      diffDecorator: Decorators.roundNumberChangeDecorator,
      tooltip: null,
      style: {},
      valueStyle: insightsCellStyles.largeValue,
    },
    avgSellingPrice: {
      type: "data",
      title: "Average Selling Price",
      taglineAccessor: null,
      accessorSection: "category",
      valueAccessor: "currentSkuAverageSellingPrice",
      valueDecorator: Decorators.priceDecoratorWrapper(
        currency,
        "average_selling_price_"
      ),
      diffAccessor: "skuAverageSellingPriceChange",
      diffDecorator: Decorators.numberChangeDecorator,
      tooltip: null,
      style: {},
      valueStyle: insightsCellStyles.largeValue,
    },
    familyTotalSales: {
      type: "data",
      title: "Product Family Total Sales",
      taglineAccessor: null,
      accessorSection: "category",
      valueAccessor: "currentFamilySalesDollars",
      valueDecorator: Decorators.priceDecoratorWrapper(
        currency,
        "current_family_sales_dollars_"
      ),
      diffAccessor: "familySalesDollarsChange",
      diffDecorator: Decorators.numberChangeDecorator,
      tooltip: null,
      style: {},
      valueStyle: insightsCellStyles.largeValue,
    },
  };
};

const PanelComp = (props) => {
  const panelConfig = CategoryCustomerPanelComponentConfig(props);
  const { currency } = props;

  const designPlan = {
    columns: [
      {
        cells: [
          {
            type: "custom",
            className: skuDetailsCellStyles.cellWrapper,
            component: SkuDetailsCell,
          },
        ],
      },
      {
        className: styles.skuDetailsDataPanels,
        rows: [
          {
            className: styles.skuDetailsDataRow,
            cells: [skuDetailsPanelConfig(currency).totalSalesDollars],
          },
          {
            className: styles.skuDetailsDataRow,
            cells: [skuDetailsPanelConfig(currency).avgSellingPrice],
          },
        ],
      },
      {
        className: styles.skuDetailsDataPanels,
        rows: [
          {
            className: styles.skuDetailsDataRow,
            cells: [skuDetailsPanelConfig(currency).unitsSold],
          },
          {
            className: styles.skuDetailsDataRow,
            cells: [skuDetailsPanelConfig(currency).familyTotalSales],
          },
        ],
      },
    ],
  };

  return (
    <PanelComponent
      {...props}
      isEnabled={true}
      className={panelStyles}
      designPlan={designPlan}
      hideHeader={true}
      hideBackground={false}
    />
  );
};

const SkuDetails = ({ familyVariantsData, status, currency }) => {
  const ComponentHolderConfig = {
    components: [
      {
        name: "Panel",
        component: PanelComp,
        actions: {
          fetch: [
            () => {
              return new Promise((res, rej) => {
                res(familyVariantsData);
              });
            },
          ],
          success: [
            (response) => {
              return { category: response };
            },
          ],
        },
        options: {},
      },
    ],
    designPlan: ["Panel"],
  };

  return (
    <div className={styles.skuDetailsContainer}>
      <ComponentsContainer
        currency={currency}
        selectedDateRange={null}
        selectedPreviousDateRange={null}
        comparePeriod={null}
        configuration={ComponentHolderConfig}
        componentsData={
          status === STATUS_SUCCESS
            ? {
                Panel: {
                  category: {
                    ...familyVariantsData,
                    ...familyVariantsData.selectedSku,
                  },
                },
              }
            : {}
        }
        categories={null}
      />
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    familyVariantsData: state.product360.product360.familyVariants.data,
    status: state.product360.product360.familyVariants.status,
  };
};

export default connect(mapStateToProps)(SkuDetails);
